module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-content"
  }, [_c('table', {
    attrs: {
      "border": "1",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('span', [_vm._v("病历号")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.mediId)
    }
  })]), _vm._v(" "), _c('td', [_c('span', [_vm._v("门诊号")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.admissionId)
    }
  })]), _vm._v(" "), _c('td', [_c('span', [_vm._v("住院号")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.admissionId)
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "info3"
  }, [_c('span', [_vm._v("就诊医院")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.hosName)
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_vm._v("患者姓名")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.patientName)
    }
  })]), _vm._v(" "), _c('td', [_c('span', [_vm._v("年龄")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.patientAge)
    }
  })]), _vm._v(" "), _c('td', [_c('span', [_vm._v("性别")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.patientSex)
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "info7"
  }, [_c('span', [_vm._v("检查类型")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.examTypeName)
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_vm._v("患者编号")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.patientId)
    }
  })]), _vm._v(" "), _c('td', [_c('span', [_vm._v("检查编号")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.accessionNumber)
    }
  })]), _vm._v(" "), _c('td', [_c('span', [_vm._v("申请科室")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.requestDepartment)
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "info11"
  }, [_c('span', [_vm._v("申请医生")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.requestDoctor)
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_vm._v("检查时间")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.studiesDoneDt)
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "info13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', [_vm._v("检查项目")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.examBodyName)
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "info14"
  }, [_c('span', [_vm._v("阴阳性")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.masculineFlag)
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "info15",
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', [_vm._v("临床诊断")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.cinicalDiagnosis)
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "info16",
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', [_vm._v("影像所见")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.reportEvidences)
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "info17",
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', [_vm._v("诊断结果")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.reportConclusion)
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "info18"
  }, [_c('span', [_vm._v("书写医生")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.reportDoctor)
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "info19"
  }, [_c('span', [_vm._v("审核医生")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.approveDoctor)
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "info20",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', [_vm._v("报告时间")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.approveDt)
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-042643da","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/report/publicReport.vue
// module id = 517
// module chunks = 1 2 3 4 5 6 7 8